import { Button, Flex, Form } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import type { TeamMemberMutationData } from "../../types/types.ts"

interface TeamMemberFormActionsProps {
  form: FormInstance<TeamMemberMutationData>
  isEdit: boolean
  saving: boolean
  onCancel: () => void
}

export function TeamMemberFormActions({
  form,
  saving,
  isEdit,
  onCancel
}: TeamMemberFormActionsProps) {
  const isInvite = Form.useWatch("is_invite", { form })

  const title = (() => {
    if (isEdit) return "Save Changes"
    return isInvite ? "Send Invitation" : "Add Member"
  })()

  return (
    <Flex align="center" justify="flex-end" gap={8} className="mt-4">
      <Button size="large" onClick={onCancel}>
        Cancel
      </Button>
      <Button
        className={"min-w-36"}
        size="large"
        type="primary"
        htmlType="submit"
        loading={saving}
      >
        {title}
      </Button>
    </Flex>
  )
}
